import { CustomDimensions } from '../types';
import {
  CustomDimensionsOrParams,
  CustomDimensionToCustomParamMap,
  CustomDimensionToUserPropertyMap,
  CustomParams,
  CustomParamsUser,
  CustomParamToCustomDimensionMap,
  UserPropertyToCustomDimensionMap,
} from './ga4Types';
import { convertObjectByDictionaries } from './utils';
import {
  customDimensionToCustomParamDictionary,
  customDimensionToUserPropertyDictionary,
  mapCustomParamToCustomDimension,
  userPropertyToCustomDimensionDictionary,
} from './ga4Maps';

/**
 * Convert custom dimensions (UA) to custom params (GA4)
 * Use only during migration
 * @param params
 * @returns
 */
export const getCustomDimensionsFromParams = (
  params: CustomDimensionsOrParams = {}
): CustomDimensions => {
  return convertObjectByDictionaries<
    CustomDimensionsOrParams,
    CustomParamToCustomDimensionMap & UserPropertyToCustomDimensionMap,
    CustomDimensionToCustomParamMap | CustomDimensionToUserPropertyMap,
    CustomDimensions
  >(
    params,
    {
      ...userPropertyToCustomDimensionDictionary,
      ...mapCustomParamToCustomDimension,
    },
    {
      ...customDimensionToUserPropertyDictionary,
      ...customDimensionToCustomParamDictionary,
    }
  );
};

/**
 * Convert custom params (GA4) to custom dimensions (UA)
 * Use only during migration
 * @param params
 * @returns
 */
export const getCustomParamsFromDimensions = (
  params: CustomDimensionsOrParams = {}
): CustomParams => {
  return convertObjectByDictionaries<
    CustomDimensionsOrParams,
    CustomDimensionToCustomParamMap,
    CustomParamToCustomDimensionMap,
    CustomParams
  >(
    params,
    customDimensionToCustomParamDictionary,
    mapCustomParamToCustomDimension
  );
};

/**
 * Convert custom dimensions (UA) to user properties (GA4 / firebase)
 */
export const getUserPropertiesFromDimensions = (
  params: CustomDimensionsOrParams = {}
): CustomParamsUser => {
  return convertObjectByDictionaries<
    CustomDimensionsOrParams,
    CustomDimensionToUserPropertyMap,
    UserPropertyToCustomDimensionMap,
    CustomParamsUser
  >(
    params,
    customDimensionToUserPropertyDictionary,
    userPropertyToCustomDimensionDictionary
  );
};
